import api from './api';

export interface ImagenRegistro {
  id: number;
  registroLimpiezaId: number;
  nombreArchivo: string;
  tipoMime: string;
  tamañoBytes: number;
  descripcion?: string;
  fechaCreacion: string;
  urlImagen: string;
}


export const imagenRegistroService = {
  // Subir una imagen
  async uploadImage(registroLimpiezaId: number, file: File, descripcion?: string): Promise<ImagenRegistro> {
    const formData = new FormData();
    formData.append('file', file, file.name); // Agregar el nombre del archivo
    if (descripcion) {
      formData.append('descripcion', descripcion);
    }

    const response = await api.post(`/ImagenRegistro/upload/${registroLimpiezaId}`, formData);
    return response.data;
  },


  // Obtener imágenes por registro de limpieza
  async getByRegistroLimpieza(registroLimpiezaId: number): Promise<ImagenRegistro[]> {
    const response = await api.get(`/ImagenRegistro/registro/${registroLimpiezaId}`);
    return response.data;
  },

  // Eliminar imagen
  async delete(id: number): Promise<void> {
    await api.delete(`/ImagenRegistro/${id}`);
  },

  // Obtener URL de descarga de imagen
  getDownloadUrl(id: number): string {
    return `${api.defaults.baseURL}/ImagenRegistro/${id}/download`;
  },

  // Descargar imagen autenticada como Blob
  async downloadBlob(id: number): Promise<Blob> {
    const response = await api.get(`/ImagenRegistro/${id}/download`, {
      responseType: 'blob',
    });
    return response.data as Blob;
  }
};
